<template>
  <span aria-hidden="true">
    <slot />
  </span>
</template>